import React from "react";

import { debounce } from "@/utils";

class ReactSlot extends React.Component {
  constructor(props) {
    super(props);
    this.dispatchEventDebounce = () => {
      document.dispatchEvent(this.event);
    };
  }

  componentDidMount() {
    this.createEvent();
    this.dispatchEventDebounce();
  }

  componentWillUnmount() {}

  createEvent = () => {
    if (typeof Event === "function") {
      this.event = new Event("react-slot-ready");
    } else {
      this.event = document.createEvent("Event");
      this.event.initEvent("react-slot-ready", true, true);
    }
  };

  render() {
    const { className, style } = this.props;
    return (
      <div
        id="react-slot-root"
        className={className || ""}
        style={style || {}}
      />
    );
  }
}

export default ReactSlot;
